import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

import LinkedTags from './LinkedPatternKeywords';
import LinkedDesignerName from '../designer/LinkedDesignerName';


const PatternExploreMore = ({ pattern, designer, sewpatId }) => {
    const Container = styled.div`
    `;

    const Flex = styled.div`
        display: flex;
        flex-wrap: nowrap;
        flex-direction: row;
        
        & span {
            margin-right: 0.5em;
        }
        
        & a {
            text-transform: capitalize;
        }
    `;

    return (
        <Container>
            <Flex>
                <FormattedMessage id='MORE_FROM_DESIGNER_PREFIX' defaultMessage='Mehr von:' />
                <LinkedDesignerName designer={designer} sewpatId={sewpatId} />
            </Flex>
            <Flex>
                <FormattedMessage id='MORE_FROM_TAGS' defaultMessage='Mehr:' />
                <LinkedTags tags={pattern.keywords} />
            </Flex>
        </Container>
    );
};

export default PatternExploreMore;



// WEBPACK FOOTER //
// ./src/components/pattern/PatternExploreMore.js